/*jshint esversion: 6 */
import { inject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { AuthService } from "../../services/authService";
import { UserMessageService } from "../../services/userMessageService";
import { EnvironmentService } from "../../services/environmentService";
import { YouTubeManagerAdminAPI } from "../../services/admin/youtubeMangerAdminAPI";
import { AccountAdminAPI } from "../../services/admin/accountAdminAPI";

@inject(
  AuthService,
  UserMessageService,
  Router,
  YouTubeManagerAdminAPI,
  EnvironmentService,
  AccountAdminAPI
)
export class YoutubeAccountManagers {
  constructor(
    authService,
    userMessageService,
    router,
    api,
    envService,
    accountApi
  ) {
    this.authService = authService;
    this.userMessageService = userMessageService;
    this.router = router;
    this.api = api;
    this.accountApi = accountApi;
    this.envService = envService;

    this.searchTemp = null;
    this.search = null;
    this.magnfi_only = false;
  }

  limitPages = [
    { id: 10, name: "10" },
    { id: 50, name: "50" },
    { id: 100, name: "100" },
  ];

  activate(params) {
    if (params.whitelabel_id) {
      this.whitelabel_id = params.whitelabel_id;
    }

    this.id = params.id;

    this.dataList = null;
    this.dataListUnasigned = null;
    this.count = null;
    this.limit = 10;
    this.page = 1;
    this.sortBy = "EMAIL";
    this.sortDir = "ASC";
    this.selectedlimitPages = 10;

    this.load();
  }
  // load user list
  load() {
    this.api.getYoutubeManagerUsers(
      this.page,
      this.limit,
      this.sortBy,
      this.sortDir,
      this.search,
      this.magnfi_only ? "NONE" : this.whitelabel_id,
      this.id,
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
    this.accountApi.getUserList(
      this.search,
      this.magnfi_only ? "NONE" : this.whitelabel_id,
      this.page,
      this.limit,
      this.sortBy,
      this.sortDir,
      this.authService.getUser().token,
      this.saveLoadSuccessUnasigned.bind(this),
      this.saveLoadError.bind(this),
      0,
      1 // premium users
    );
  }

  saveLoadSuccess(data) {

    this.setData(data);
  }

  saveLoadSuccessUnasigned(data) {
    this.setDataUnasigned(data);
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError("user", msg);
  }

  asignLoadSuccess(msg) {
    this.userMessageService.setUserMessage("user", "Asigned");
    this.load();
  }

  setData(data) {

    this.dataList = data.list;
    this.count = data.count;
    this.pages = Math.floor(this.count / this.limit);
    this.pages =
      this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
  }

  setDataUnasigned(data) {
    this.dataListUnasigned = data.list;
    this.countUnasigned = data.count;
    this.pagesUnasigned = Math.floor(this.countUnasigned / this.limitUnasigned);
    this.pagesUnasigned =
      this.pagesUnasigned * this.limitUnasigned <= this.countUnasigned
        ? this.pagesUnasigned + 1
        : this.pagesUnasigned;
  }

  rowClicked(item) {
    this.router.navigate("user/" + item.id);
  }

  asignUser(id) {

    this.api.asignUser(
      { id, managerId: this.id },
      this.authService.getUser().token,
      this.asignLoadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );

  }

  columnClicked(name) {
    $(".sorting").removeClass("sorting_asc");
    $(".sorting").removeClass("sorting_desc");
    if (this.sortBy == name) {
      if (this.sortDir == "ASC") {
        this.sortDir = "DESC";
        $("#" + name).addClass("sorting_desc");
      } else {
        this.sortDir = "ASC";
        $("#" + name).addClass("sorting_asc");
      }

      this.load();
    } else {
      this.sortBy = name;
      this.sortDir = "DESC";
      $("#" + name).addClass("sorting_desc");
      this.load();
    }
  }

  prev() {
    if (this.page > 1) {
      this.page--;
      this.dataList = null;
      this.load();
    }
  }

  next() {
    if (this.page < this.pages) {
      this.page++;
      this.dataList = null;
      this.load();
    }
  }

  limitChange() {
    console.log("event called", this.selectedlimitPages);
    if (this.limit != this.selectedlimitPages) {
      this.limit = this.selectedlimitPages;
      this.dataList = null;
      this.load();
    }
  }

  prevUnasined() {
    if (this.pageUnasined > 1) {
      this.pageUnasined--;
      this.dataListUnasined = null;
      this.load();
    }
  }

  nextUnasined() {
    if (this.pageUnasined < this.pagesUnasined) {
      this.pageUnasined++;
      this.dataListUnasined = null;
      this.load();
    }
  }

  limitChangeUnasined() {
    console.log("event called", this.selectedlimitPagesUnasined);
    if (this.limitUnasined != this.selectedlimitPagesUnasined) {
      this.limitUnasined = this.selectedlimitPagesUnasined;
      this.dataListUnasined = null;
      this.load();
    }
  }

  handleKeypress(event) {
    if (event.keyCode == 13) {
      this.search = this.searchTemp;
      this.load();
      //event.preventDefault();
      return false;
    }

    return true;
  }

  search_user() {
    this.search = this.searchTemp;
    this.load();
  }
}
